<template>
  <div class="flex flex-col gap-2.5">
    <CardBody
      class="child:text-navy"
      :text="location"
      :textSize="'small'"></CardBody>
    <CardEventTime
      :date="eventTime.startTime ? eventTime.startTime.iso8601 : ''"
      >{{ time }}</CardEventTime
    >
    <a
      class="text-navy font-bold hover:no-underline focus:no-underline"
      :href="eventRegisterLink">
      Register
    </a>
  </div>
</template>

<script>
import CardBody from "./CardBody.vue";
import CardEventTime from "./CardEventTime.vue";

export default {
  components: {
    CardBody,
    CardEventTime,
  },

  props: {
    eventLocation: {
      type: [String, null],
      required: true,
    },
    eventTime: {
      type: [Object, null],
      required: true,
    },
    eventRegisterLink: {
      type: [String, null],
      required: true,
    },
  },

  setup(props) {
    const location = `<p>${props.eventLocation}</p>`;

    const formatTime = (time) => {
      time = time.replace("AM", "a.m.");
      time = time.replace("PM", "p.m.");

      return time;
    };

    let time;

    if (props.eventTime.startTime) {
      const startDate = new Date(props.eventTime.startTime.iso8601);
      const startOptions = {
        hour: "numeric",
        minute: "numeric",
      };
      let start = new Intl.DateTimeFormat("en-US", startOptions).format(
        startDate
      );

      time = formatTime(start);
    }

    if (props.eventTime.endTime) {
      const endDate = new Date(props.eventTime.endTime.iso8601);

      const endOptions = {
        timeZoneName: "short",
        hour: "numeric",
        minute: "numeric",
      };

      let end = new Intl.DateTimeFormat("en-US", endOptions).format(endDate);

      time = time + " - " + formatTime(end);
    }

    return {
      location,
      time,
    };
  },
};
</script>
